import { Button } from '@design-system';

import { ChevronLeft, ChevronRight, Loader2, SkipForward } from 'lucide-react';

interface AdvisorOnboardingFooterProps {
  currentStep: number;
  totalSteps: number;
  onNext?: () => void;
  onSkip?: () => void;
  onPrev?: () => void;
  isNextDisabled?: boolean;
  isNextLoading?: boolean;
  hideSkip?: boolean;
  hideNext?: boolean;
  hidePrev?: boolean;
  lastStepButtonLabel?: string;
  hasSkippedBefore?: boolean;
  allowSkipOnLastStep?: boolean;
  skipWithoutConfirmation?: boolean;
}

export function AdvisorOnboardingFooter({
  currentStep,
  totalSteps,
  onNext,
  onSkip,
  onPrev,
  isNextDisabled,
  isNextLoading,
  hideSkip,
  hideNext = false,
  hidePrev = false,
  lastStepButtonLabel = 'Go to Dashboard',
  allowSkipOnLastStep = false,
}: AdvisorOnboardingFooterProps) {
  const isPrevButtonVisible = !hidePrev && currentStep > 0;
  const lastStep = currentStep + 1 === totalSteps;
  const showSkipButton = !hideSkip && (!lastStep || allowSkipOnLastStep);

  return (
    <div className="border-border sticky bottom-0 z-20 border-t bg-white">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-6 p-6">
        {showSkipButton && (
          <Button
            size="lg"
            variant="ghost"
            onClick={onSkip}
            className="rounded-full"
          >
            <SkipForward />
            Skip for now
          </Button>
        )}
        <div className="ml-auto flex items-center gap-4">
          {isPrevButtonVisible && (
            <Button
              size="lg"
              variant="outline"
              onClick={onPrev}
              className="pr-6! rounded-full"
            >
              <ChevronLeft />
              Back
            </Button>
          )}
          {!hideNext && (
            <Button
              size="lg"
              onClick={onNext}
              disabled={isNextDisabled || isNextLoading}
              className="pl-6! rounded-full"
            >
              {isNextLoading ? (
                <>
                  <Loader2 className="animate-spin" />
                  Saving...
                </>
              ) : (
                <>
                  {lastStep ? lastStepButtonLabel : 'Next'}
                  <ChevronRight />
                </>
              )}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
